import { render, staticRenderFns } from "./EducationalPeriodForm.vue?vue&type=template&id=4e8c0d96&"
import script from "./EducationalPeriodForm.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports